// import { StrictMode } from "react"; // TEMPORARILY DISABLED for debugging
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { store } from "./store";
import { captureCampaignAttribution } from "./utils/campaignAttribution";
import { removeLegacyAnalytics } from "./utils/removeLegacyAnalytics";
import "./index.css";
import "./config/i18n";
import "./config/logging";

removeLegacyAnalytics();
captureCampaignAttribution(window.location.search);

createRoot(document.getElementById("root")!).render(
  // <StrictMode> // TEMPORARILY DISABLED for debugging
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  // </StrictMode>,
);
